/**
 * Simple I18n interpolation function for client-side translation
 * Replaces placeholders like %{variable} with actual values
 *
 * @param {string} template - Translation template with %{variable} placeholders
 * @param {Object} vars - Variables to interpolate
 * @returns {string} - Interpolated string
 *
 * @example
 * interpolate("%{region}%{subject}教師", { region: "台北市", subject: "數學" })
 * // => "台北市數學教師"
 *
 * @example
 * interpolate("%{region}專業%{subject}教師免費媒合，學生免費搜尋，老師零抽成。", {
 *   region: "台中市",
 *   subject: "英文"
 * })
 * // => "台中市專業英文教師免費媒合，學生免費搜尋，老師零抽成。"
 */
export function interpolate(template, vars = {}) {
  if (!template) return '';

  return template.replace(/%\{(\w+)\}/g, (match, key) => {
    return vars[key] !== undefined ? vars[key] : match;
  });
}
